import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import TitleInput from "../../components/molecules/input/titleInput";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import RightLabelCheckbox from "../../components/molecules/checkbox/rightLabelCheckbox";
import TermModal from "../../components/templates/modals/termModal";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import AuthApi from "../../api/auth.api";
import { toast } from "react-toastify";
import { errorHandler } from "../../util/errorHandler";

let termsType;

let timer;

const Register = () => {
  let min = 3;
  let sec = 0;

  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();
  const location = useLocation();

  const { joinType, socialId, userData } = location.state || {};

  const [id, setId] = useState("");
  const [idErrorM, setIdErrorM] = useState("");
  const [idCheck, setIdCheck] = useState(false);
  const [idCheckM, setIdCheckM] = useState("");

  const [pw, setPw] = useState("");
  const [pwErrorM, setPwErrorM] = useState("");
  const [pwConfirm, setPwConfirm] = useState("");
  const [pwConfirmErrorM, setPwConfirmErrorM] = useState("");

  const [nickName, setNickName] = useState("");
  const [nickNameErrorM, setNickNameErrorM] = useState("");
  const [nicknameCheck, setNicknameCheck] = useState(false);
  const [nicknameCheckM, setNicknameCheckM] = useState("");

  const [name, setName] = useState("");
  const [nameErrorM, setNameErrorM] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneErrorM, setPhoneErrorM] = useState("");
  const [phoneCheck, setPhoneCheck] = useState(false);
  const [phoneCheckM, setPhoneCheckM] = useState("");

  const [smsToken, setSmsToken] = useState("");
  const [smsVerificationToken, setSmsVerificationToken] = useState("");

  const [certifiedNum, setCertifiedNum] = useState("");
  const [certifiedNumErrorM, setCertifiedNumErrorM] = useState("");
  const [certifiedNumCheckM, setCertifiedNumCheckM] = useState("");

  const [minState, setMinState] = useState(3);
  const [secState, setSecState] = useState(0);

  const [birth, setBirth] = useState("");
  const [birthErrorM, setBirthErrorM] = useState("");
  const [email, setEmail] = useState("");
  const [emailErrorM, setEmailErrorM] = useState("");

  const [allAgree, setAllAgree] = useState("");
  const [agree01, setAgree01] = useState(false);
  const [agree02, setAgree02] = useState(false);
  const [agree03, setAgree03] = useState(false);
  const [agree04, setAgree04] = useState(false);
  const [agree05, setAgree05] = useState(false);
  const [agree06, setAgree06] = useState(false);

  const [isTermModal, setIsTermModal] = useState(false);

  const [btnDisabled, setBtnDisabled] = useState(true);

  useEffect(() => {
    if (userData) {
      setId(socialId);
      setNickName(userData.nickname);
      setPhone(userData.phone);
      setEmail(userData.email);
      setName(userData.name);
    }
  }, [userData]);

  useEffect(() => {
    if (agree01 && agree02 && agree03 && agree04 && agree05 && agree06) {
      setAllAgree(true);
    } else {
      setAllAgree(false);
    }
  }, [agree01, agree02, agree03, agree04, agree05, agree06]);

  useEffect(() => {
    if (allAgree) {
      setAgree01(true);
      setAgree02(true);
      setAgree03(true);
      setAgree04(true);
      setAgree05(true);
      setAgree06(true);
    }
  }, [allAgree]);

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      clearTimer("타이머 종료");
    };
  }, []);

  const countTimerStart = () => {
    timer = setInterval(countTimer, 1000);
  };

  const countTimer = () => {
    if (sec != 0) {
      sec = sec - 1;
      setSecState(sec);
    } else {
      if (min != 0) {
        min = min - 1;
        sec = 59;

        setSecState(sec);
        setMinState(min);
      } else {
        clearTimer("타이머 종료");
        setCertifiedNumErrorM("인증에 실패했습니다. 인증을 다시 시도하세요.");
      }
    }
  };

  function clearTimer(text) {
    clearInterval(timer);

    if (text === "타이머 종료") {
      min = 3;
      setMinState(3);
      sec = 0;
      setSecState(0);
    }
  }

  useEffect(() => {
    if (
      agree01 &&
      agree02 &&
      agree03 &&
      (id || socialId != null) &&
      (idErrorM === "" || socialId != null) &&
      (idCheck || socialId != null) &&
      nickName &&
      nickNameErrorM === "" &&
      nicknameCheck &&
      name &&
      nameErrorM === "" &&
      phone &&
      phoneErrorM === "" &&
      certifiedNum &&
      certifiedNumCheckM !== "" &&
      birth &&
      birthErrorM === "" &&
      email &&
      emailErrorM === "" &&
      (pw || socialId != null) &&
      (pwErrorM === "" || socialId != null) &&
      (pwConfirm || socialId != null) &&
      (pwConfirmErrorM === "" || socialId != null)
    ) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [
    agree01,
    agree02,
    agree03,
    id,
    idErrorM,
    idCheck,
    pw,
    pwErrorM,
    pwConfirm,
    pwConfirmErrorM,
    nickName,
    nickNameErrorM,
    nicknameCheck,
    name,
    nameErrorM,
    phone,
    phoneErrorM,
    certifiedNum,
    certifiedNumCheckM,
    birth,
    birthErrorM,
    email,
    emailErrorM,
  ]);

  useEffect(() => {
    if (id.length > 0) {
      const regType1 = /^[A-Za-z0-9]+$/;

      if (!regType1.test(id)) {
        return setIdErrorM("아이디에 특수문자와 공백은 불가합니다.");
      }

      setIdErrorM("");
      setIdCheckM("");
      setIdCheck(false);
    }
  }, [id]);

  const idCheckFunc = async () => {
    try {
      const obj = {
        account: id,
      };
      const response = await AuthApi.idCheck(obj);

      setIdCheck(true);
      setIdCheckM("사용 가능한 아이디 입니다.");
    } catch (error) {
      setIdCheck(false);
      setIdErrorM("이미 등록된 아이디 입니다.");
      setIdCheckM("");
    }
  };

  useEffect(() => {
    if (pw.length > 0) {
      const regType1 =
        /^(?=.*[A-Za-z])(?=.*\d|(?=.*[!@#$%^&*(),.?":{}|<>]))|(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])/;

      if (!regType1.test(pw)) {
        return setPwErrorM("비밀번호 조합이 올바르지 않습니다.");
      }

      if (pw.length < 8) {
        return setPwErrorM("비밀번호 8자리 이상을 입력해주세요. ");
      }

      setPwErrorM("");
    }
  }, [pw]);

  useEffect(() => {
    if (pwConfirm.length > 0) {
      if (pwConfirm !== pw) {
        return setPwConfirmErrorM("비밀번호가 일치하지 않습니다.");
      }

      setPwConfirmErrorM("");
    }
  }, [pwConfirm]);

  useEffect(() => {
    if (nickName.length > 0) {
      const regType1 = /^[^\s]{1,10}$/;

      if (!regType1.test(nickName)) {
        return setNickNameErrorM("닉네임 형식이 올바르지 않습니다.");
      }

      setNickNameErrorM("");
      setNicknameCheckM("");
      setNicknameCheck(false);
    }
  }, [nickName]);

  const nicknameCheckFunc = async () => {
    try {
      const obj = {
        nickname: nickName,
      };
      const response = await AuthApi.nicknameCheck(obj);

      setNicknameCheck(true);
      setNicknameCheckM("사용 가능한 닉네임 입니다.");
    } catch (error) {
      setNicknameCheck(false);
      setNickNameErrorM("이미 등록된 닉네임 입니다.");
      setNicknameCheckM("");
    }
  };

  useEffect(() => {
    if (phone.length > 0) {
      const regex = /^\d*$/;
      if (!regex.test(phone)) {
        return setPhoneErrorM("숫자만 입력해주세요.");
      }

      setPhoneErrorM("");
      setPhoneCheckM("");
      setPhoneCheck(false);
      setCertifiedNumCheckM("");
      setSmsVerificationToken("");
    }
  }, [phone]);

  useEffect(() => {
    if (phoneCheck) {
      setCertifiedNum("");
      setCertifiedNumErrorM("");
      setCertifiedNumCheckM("");
    }
  }, [phoneCheck]);

  const phoneCheckFunc = async () => {
    try {
      const obj = {
        phoneNumber: phone,
      };
      const response = await AuthApi.phoneCheck(obj);

      phoneSendFunc();
    } catch (error) {
      setPhoneCheck(false);
      setPhoneErrorM("이미 회원가입된 전화번호입니다.");
      setPhoneCheckM("");
    }
  };

  const phoneSendFunc = async () => {
    try {
      const obj = {
        phoneNumber: phone,
      };
      const response = await AuthApi.sendSMS(obj);

      clearTimer("타이머 종료");

      setSmsToken(response.data.data.smsToken);
      setSmsVerificationToken("");
      setPhoneCheck(true);
      countTimerStart();
      toast(
        response.data.data.authNumber
          ? "개발용 인증번호는 000000입니다."
          : "인증번호가 발송되었습니다.",
      );
    } catch (error) {
      setPhoneCheck(false);
      toast(`인증번호 발송에 실패하였습니다.`);
    }
  };

  const certifiedNumCheckFunc = async () => {
    try {
      const response = await AuthApi.verifySMS({
        phoneNumber: phone,
        authNumber: certifiedNum,
        smsToken,
      });
      setSmsVerificationToken(
        response.data.data.smsVerificationToken,
      );
      setCertifiedNumErrorM("");
      setCertifiedNumCheckM("인증되었습니다.");
      setPhoneCheck(false);
      clearTimer("타이머 종료");
    } catch (error) {
      setSmsVerificationToken("");
      setCertifiedNumErrorM(
        "인증번호가 일치하지 않거나 만료되었습니다. 다시 시도하세요.",
      );
    }
  };

  useEffect(() => {
    if (birth.length > 0) {
      const regex = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/;
      if (!regex.test(birth)) {
        return setBirthErrorM("생년월일이 올바르지 않습니다.");
      }

      setBirthErrorM("");
    }
  }, [birth]);

  useEffect(() => {
    if (email.length > 0) {
      let regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      if (!regex.test(email)) {
        return setEmailErrorM("이메일 형식이 올바르지 않습니다.");
      }

      setEmailErrorM("");
    }
  }, [email]);

  //회원가입 처리
  const handleJoin = async () => {
    try {
      if (socialId != null) {
        const obj = {
          name: name,
          nickname: nickName,
          birth: birth,
          phoneNumber: phone,
          email: email,
          marketingAgreement: agree04,
          adAgreement: agree05,
          smsAgreement: agree06,
          smsVerificationToken,
        };

        await AuthApi.socialJoin(joinType, id, obj);
        toast("회원가입이 완료되었습니다.");
        navigate(route.login, {
          replace: true,
        });
      } else {
        const obj = {
          name: name,
          nickname: nickName,
          birth: birth,
          phoneNumber: phone,
          email: email,
          marketingAgreement: agree04,
          adAgreement: agree05,
          smsAgreement: agree06,
          smsVerificationToken,
        };

        await AuthApi.join(id, pw, obj);
        toast("회원가입이 완료되었습니다.");
        navigate(route.login);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <RegisterSection>
        <PCContainer
          style={{
            padding: isSmall ? "80px 20px 80px 20px" : "80px 0px 158px 0px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: isMobile ? "100%" : 790,
              padding: isMobile
                ? "0px"
                : isTablet
                ? "60px 140px"
                : "60px 205px",
              boxShadow: isMobile ? "none" : "0px 0px 6px 0px #0000001A",
              borderRadius: isMobile ? 0 : 30,
            }}
          >
            <LSBdDisplay02
              style={{
                textAlign: "center",
                marginBottom: 32,
              }}
            >
              회원가입
            </LSBdDisplay02>
            {socialId != null ? null : (
              <>
                <TitleInput
                  title={"아이디"}
                  essential={true}
                  placeholder={"아이디를 입력해 주세요."}
                  type={"text"}
                  onChange={(e) => {
                    setId(e.target.value);
                  }}
                  value={id}
                  warningMessage={idErrorM}
                  checkMessage={idCheckM}
                  style={{
                    marginBottom: 20,
                  }}
                  isRightButton={true}
                  isRightButtonText={"중복확인"}
                  rightButtonOnClick={() => {
                    if (id && idErrorM === "") {
                      idCheckFunc();
                    }
                  }}
                  autocomplete={"one-time-code"}
                />

                <TitleInput
                  title={"비밀번호"}
                  essential={true}
                  placeholder={"비밀번호를 입력해 주세요."}
                  type={"password"}
                  onChange={(e) => {
                    setPw(e.target.value);
                  }}
                  value={pw}
                  warningMessage={pwErrorM}
                  style={{
                    marginBottom: 20,
                  }}
                  guideMessage={
                    "문자/숫자/특수기호 중 2가지 이상 조합 (글자수 8자~16자)"
                  }
                  autocomplete={"one-time-code"}
                  maxLength={16}
                />

                <TitleInput
                  title={"비밀번호 확인"}
                  essential={true}
                  placeholder={"비밀번호를 입력해 주세요."}
                  type={"password"}
                  onChange={(e) => {
                    setPwConfirm(e.target.value);
                  }}
                  value={pwConfirm}
                  warningMessage={pwConfirmErrorM}
                  style={{
                    marginBottom: 20,
                  }}
                  maxLength={16}
                  autocomplete={"one-time-code"}
                />
              </>
            )}

            <TitleInput
              title={"닉네임"}
              essential={true}
              placeholder={"닉네임을 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setNickName(e.target.value);
              }}
              value={nickName}
              warningMessage={nickNameErrorM}
              checkMessage={nicknameCheckM}
              style={{
                marginBottom: 20,
              }}
              guideMessage={
                "띄어쓰기 없이 최대 10자 제한 (한글, 영문, 숫자만 사용 가능)"
              }
              maxLength={10}
              isRightButton={true}
              isRightButtonText={"중복확인"}
              rightButtonOnClick={() => {
                if (nickName && nickNameErrorM === "") {
                  nicknameCheckFunc();
                }
              }}
              autocomplete={"one-time-code"}
            />

            <TitleInput
              title={"이름"}
              essential={true}
              placeholder={"이름을 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setName(e.target.value);
              }}
              value={name}
              warningMessage={nameErrorM}
              style={{
                marginBottom: 20,
              }}
              maxLength={30}
            />

            <TitleInput
              title={"전화번호"}
              essential={true}
              placeholder={"전화번호를 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              value={phone}
              warningMessage={phoneErrorM}
              checkMessage={certifiedNumCheckM}
              style={{
                marginBottom: 20,
              }}
              isRightButton={true}
              isRightButtonText={"인증발송"}
              rightButtonOnClick={() => {
                if (phone && phoneErrorM === "") {
                  phoneCheckFunc();
                }
              }}
              maxLength={11}
            />

            {phoneCheck ? (
              <TitleInput
                title={"인증코드"}
                essential={true}
                placeholder={"인증코드 6자리를 입력해 주세요."}
                type={"text"}
                onChange={(e) => {
                  setCertifiedNum(e.target.value);
                }}
                value={certifiedNum}
                warningMessage={certifiedNumErrorM}
                checkMessage={certifiedNumCheckM}
                style={{
                  marginBottom: 20,
                }}
                isRightButton={true}
                isRightButtonText={"인증"}
                isRightButtonStyle={{
                  right: "-2%",
                }}
                isTimer={true}
                min={minState}
                sec={secState}
                timerStyle={{}}
                rightButtonOnClick={() => {
                  certifiedNumCheckFunc();
                }}
                maxLength={6}
              />
            ) : null}

            <TitleInput
              title={"생년월일"}
              essential={true}
              placeholder={"YYYYMMDD"}
              type={"text"}
              onChange={(e) => {
                setBirth(e.target.value);
              }}
              value={birth}
              warningMessage={birthErrorM}
              style={{
                marginBottom: 20,
              }}
              maxLength={8}
            />

            <TitleInput
              title={"이메일"}
              essential={true}
              placeholder={"이메일을 입력해 주세요."}
              type={"text"}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              value={email}
              warningMessage={emailErrorM}
              style={{
                marginBottom: 28,
              }}
              autocomplete={"one-time-code"}
            />

            <RightLabelCheckbox
              textStyle={{
                color: "#101113",
                fontWeight: 700,
                fontSize: isMobile ? 12 : 16,
                fontFamily: "LINESeedKR-Bd",
              }}
              inputStyle={{
                marginBottom: 16,
              }}
              checked={allAgree}
              onChange={() => {
                if (allAgree) {
                  setAgree01(false);
                  setAgree02(false);
                  setAgree03(false);
                  setAgree04(false);
                  setAgree05(false);
                  setAgree06(false);
                }

                setAllAgree(!allAgree);
              }}
              text={"약관 전체 동의"}
            />

            <div
              style={{
                height: 1,
                background: "#DBDDE0",
                width: "100%",
                marginBottom: 16,
              }}
            />

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <RightLabelCheckbox
                checked={agree01}
                onChange={() => {
                  setAgree01(!agree01);
                }}
                text={"[필수] 만 14세 이상입니다."}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <RightLabelCheckbox
                checked={agree02}
                onChange={() => {
                  setAgree02(!agree02);
                }}
                text={"[필수] 이용약관에 동의합니다."}
              />
              <LSRgCaption02
                onClick={() => {
                  termsType = 9;
                  setIsTermModal(true);
                }}
                style={{
                  textAlign: "right",
                  color: "#A4A8B1",
                  cursor: "pointer",
                  minWidth: 42,
                  textDecoration: "underline",
                }}
              >
                전체보기
              </LSRgCaption02>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 12,
              }}
            >
              <RightLabelCheckbox
                checked={agree03}
                onChange={() => {
                  setAgree03(!agree03);
                }}
                text={"[필수] 개인정보 수집 및 이용에 동의합니다."}
              />
              <LSRgCaption02
                onClick={() => {
                  termsType = 8;
                  setIsTermModal(true);
                }}
                style={{
                  textAlign: "right",
                  color: "#A4A8B1",
                  cursor: "pointer",
                  minWidth: 42,
                  textDecoration: "underline",
                }}
              >
                전체보기
              </LSRgCaption02>
            </div>
            <RightLabelCheckbox
              textStyle={{
                maxWidth: 315,
              }}
              inputStyle={{
                marginBottom: 12,
              }}
              checked={agree04}
              onChange={() => {
                setAgree04(!agree04);
              }}
              text={"[선택] 마케팅 목적의 개인정보 수집 및 이용에 동의합니다."}
            />
            <RightLabelCheckbox
              textStyle={{
                maxWidth: 315,
              }}
              inputStyle={{
                marginBottom: 12,
              }}
              checked={agree05}
              onChange={() => {
                setAgree05(!agree05);
              }}
              text={"[선택] 광고성 정보 수신에 동의합니다."}
            />
            <RightLabelCheckbox
              textStyle={{
                maxWidth: 315,
              }}
              inputStyle={{}}
              checked={agree06}
              onChange={() => {
                setAgree06(!agree06);
              }}
              text={"[선택] SMS 수신에 동의합니다."}
            />

            <MainBtn
              disabled={btnDisabled}
              onClick={() => {
                handleJoin();
              }}
              style={{
                marginTop: 28,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                회원가입 완료
              </LSRgH1HeadLine>
            </MainBtn>
          </div>
        </PCContainer>
      </RegisterSection>

      {isTermModal ? (
        <TermModal
          setVisiable={setIsTermModal}
          isScroll={false}
          termCategory={termsType}
        />
      ) : null}
    </>
  );
};

export default Register;

const RegisterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
